import { useMutation } from 'react-query';
import { ActionDataType } from 'mdello-client-ts';
import { useNotification } from 'src/providers/notificationsProvider';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { UseMutationInterface } from 'src/reactQuery/customers/mutations/interfaces/useUpdateCustomer.interface';
import { downloadRequestActionsCsv } from 'src/services/napi/requestActions/dowloadRequestActionsCsv';

const onDownloadVacationsCsv = async (): Promise<void> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  await downloadRequestActionsCsv({
    projectId: currentProject._id,
    type: ActionDataType.ACTION_DATA_VACATION
  });
};

export const useDownloadVacations = ({ onError, onSuccess }: UseMutationInterface) => {
  const { notify } = useNotification();

  return useMutation(() => onDownloadVacationsCsv(), {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
